__turbopack_context__.v({
  "button": "Button-module__8RiFmG__button",
});
